import { PAYPAL_SANDBOX } from "./paypal";

// ─── All Apps Bundle (/subscribe) ─────────────────────────────────────────────
// Not ready to sell, so it stays out of release builds: its PayPal plan lives in a
// different account than the one the live build is configured for, and the panel on
// the account page still renders hardcoded demo data. Testing builds keep showing it
// so it can be finished.
//
// This gates the header link, the mobile drawer link, the /subscribe route and the
// SubscriptionPanel on the account page. With the route gone, /subscribe falls
// through to the catch-all and renders the home page.
export const BUNDLE_ENABLED = PAYPAL_SANDBOX;
